export const iconFontAwesomeAutomotiveChargingStation = (
	<i className="fa-solid fa-charging-station"></i>
);
